var MainMenu = (function() {

    var $listItems = $( '#primary-nav > ul > li' ),
        $menuItems = $listItems.children( 'a' ),
        $body = $( 'body' ),
        current = -1;


    function init() {
        $menuItems.on( 'click', open );
        $listItems.on( 'click', function( event ) { event.stopPropagation(); } );
    }

    function open( event ) {
        if( current !== -1 ) {
            $listItems.eq( current ).removeClass( 'open' );
        }

        var $item = $( event.currentTarget ).parent( 'li' ),
            idx = $item.index();

        console.log($item, $($item).children('div.sub').length);

        if($($item).children('div.sub').length == 0) return true;

        if($item.hasClass('logo')) return true;

        if( current === idx ) {
            $item.removeClass( 'open' );
            current = -1;
        }
        else {
            $item.addClass( 'open' );
            current = idx;
            $body.off( 'click' ).on( 'click', close );
        }

        return false;

    }

    function close( event ) {
        $listItems.eq( current ).removeClass( 'open' );
        current = -1;
    }

    return { init : init };

})();

$(function() {
    MainMenu.init();
});


function toggleMobileMenu() {
    $("html").toggleClass('nav-is-open');
    $("nav.primary").toggleClass('nav-open');
    $(".nav__container").toggleClass('nav-open');
}

$(".menu-button").on('click', function(e) {
    e.preventDefault();
    toggleMobileMenu();
});

$( '.mobile-search [type="submit"]').on('click', function(e) {
    toggleMobileMenu();
});

if ($(window).width() <= 1024) {
    $( ".sub" ).slideUp();

    $(".menu-item-has-children").on('click', function() {
        $(this).toggleClass('sub-open');
        $(this).find(".sub").slideToggle( 250 );
    });
}

